/** @jsxImportSource @emotion/react */

import { useQuery } from "react-query";
import { useParams } from "react-router";
import { Screen } from "../components";
import { getRecord } from "../utils/record";

import * as colors from "../styles/colors";
import { Link } from "react-router-dom";
import { medium, small } from "../styles/media-queries";

function Record() {
  const { recordAddress } = useParams();
  return (
    <Screen>
      <h1
        css={{
          textAlign: "center",
          margin: "1em",
          [medium]: {
            fontSize: "1.29em",
          },
          [small]: {
            fontSize: "0.76em",
          },
        }}
      >
        {recordAddress}
      </h1>
      <RecordCard />
      <Link
        to={`/records`}
        css={{
          width: "max-content",
          margin: "2em auto",
          display: "block",
          color: colors.white,
          textDecoration: "none",
          backgroundColor: colors.primary,
          padding: "1em 2em",
          borderRadius: "0.6em",
        }}
      >
        Back to Records
      </Link>
    </Screen>
  );
}

function RecordCard() {
  const { recordAddress } = useParams();
  const {
    isIdle,
    isLoading,
    isFetching,
    error,
    data: record,
  } = useQuery(["record", recordAddress], () => getRecord(recordAddress));

  if (isLoading || isIdle || isFetching)
    return <p css={{ textAlign: "center" }}>Fetching Record...</p>;

  if (error)
    return (
      <div css={{ textAlign: "center" }}>
        <p>Something went wrong!</p>
        <p css={{ marginTop: "1em" }}>{error.message}</p>
      </div>
    );

  if (!record) return <p css={{ textAlign: "center" }}>No Record Found!</p>;

  return (
    <div
      css={{
        margin: "1em auto",
        width: "90%",
        "& > div": {
          flex: "1 0 calc(50% - 1em)",
        },
        [medium]: {
          width: "90%",
        },
        [small]: {
          width: "90%",
        },
      }}
    >
      <DetailRow label="Name" value={record.name} />
      <DetailRow label="Age" value={record.age} />
      <DetailRow label="Gender" value={record.gender} />
      <DetailRow label="Blood Group" value={record.bloodgroup} />
      <DetailRow label="Address" value={record.patientaddress} />
      <DetailRow label="Illness Details" value={record.patientillness} />
      <DetailRow label="Medical Records" value={record.patientmedicalrecords} />
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div
      css={{
        display: "flex",
        justifyContent: "space-between",
        margin: "1em 0",
        flexDirection: "column",
        backgroundColor: colors.white,
        padding: "0.6em",
        borderRadius: "0.3em"
      }}
    >
      <div css={{ color: colors.secondary, fontSize: "0.76rem" }}>{label}:</div>
      <div css={{ fontWeight: "600", color: colors.black }}>{value}</div>
    </div>
  );
}

export default Record;
